import {ThemeColorName, ThemeType} from '../../../theme/types';
import {BaseBorderPxProps} from '../../base/types';
import {mapBorderToBaseProperties} from '../../themed/functions';
import {ThemeBorderPxProps, ThemeFocusBorder} from '../../types';

const focusStyleMap: {
  [key in 'on' | 'off']: {
    borderColor: ThemeColorName;
  };
} = {
  on: {
    borderColor: 'border_accent_default',
  },
  off: {
    borderColor: 'transparent',
  },
};

export const mapFocusBorderToBaseProperties = (
  theme: ThemeType,
  focusBorder: ThemeFocusBorder | undefined,
  defaultProps: ThemeBorderPxProps = {},
): BaseBorderPxProps => {
  if (focusBorder === undefined || focusBorder === 'none') {
    return mapBorderToBaseProperties(theme, defaultProps);
  }

  return mapBorderToBaseProperties(theme, {
    ...defaultProps,
    borderColor: focusStyleMap[focusBorder].borderColor,
    borderWidth: '2',
    borderStyle: 'solid',
    borderPosition: 'inside',
  });
};
